import type { Input } from './Input';

const MAX_PITCH = (89 * Math.PI) / 180;

/**
 * Shared yaw/pitch view state. One instance serves both the player and the
 * noclip fly camera so the view direction survives mode toggles.
 */
export class MouseLook {
  yaw = 0;
  pitch = -0.1;
  /** Radians per pixel — set from Settings, editable in the tuning panel. */
  sensitivity = 0.0022;
  /** Yaw change applied on the most recent update — feeds strafe-sync stats. */
  lastYawDelta = 0;

  constructor(private readonly input: Input) {}

  update(): void {
    const { dx, dy } = this.input.consumeMouseDelta();
    const yawDelta = -dx * this.sensitivity;
    this.yaw += yawDelta;
    this.lastYawDelta = yawDelta;
    this.pitch = Math.max(-MAX_PITCH, Math.min(MAX_PITCH, this.pitch - dy * this.sensitivity));
  }
}
